module.exports = __webpack_public_path__ + "img/beer_id-84.1f12214b.png";